function hasPermissionSmart(
  permissions: Array<string> | null,
  permission: string,
): boolean {
  const _permissions = permissions ?? [];

  const [app, model] = permission.split('.');
  if (!app || !model) {
    // Se o formato não for app.model, faz verificação direta
    return _permissions.includes(permission);
  }

  const permsToCheck = [
    `${app}.add_${model}`,
    `${app}.change_${model}`,
    `${app}.delete_${model}`,
    `${app}.view_${model}`,
  ];

  return _permissions.some((p) => permsToCheck.includes(p));
}

function hasPermission(permissions: Array<string> | null, permission: string) {
  const _permissions = permissions == null ? [] : permissions;
  return _permissions.indexOf(permission) !== -1;
}

export { hasPermissionSmart, hasPermission };
